/**
 * Контроллер для работы с картой
 * @module PageGeo/Controller/Map
 */
import * as webix from 'webix'
import MapUI from 'PageGeo/views/map.ui'
import ymaps from 'ymaps'
import * as geoService from 'API/geoService'

export default class Map {
  constructor(initObj) {

    this.ui = new MapUI()
    this.SaveWnd = initObj.SaveWnd

    this.id = this.ui.id
    this.app = webix.ui(this.ui)
    this.yampsUrl = initObj.ymapsUrl
    this.api = initObj.apiUrl

    if (this.region) {
      $$(`${this.id}ToolbarLabel`)
        .define('label', this.region.name)
      $$(`${this.id}ToolbarLabel`)
        .refresh()
    }

    webix.extend($$(this.id), webix.ProgressBar)
  }

  /**
   * Обработчик событий
   */
  eventHandler() {
    $$(`${this.id}BtnStart`)
      .attachEvent('onItemClick', () => this.startDrawing())
    $$(`${this.id}BtnStop`)
      .attachEvent('onItemClick', () => this.stopDrawing())
    $$(`${this.id}BtnClear`)
      .attachEvent('onItemClick', () => this.clean())
    $$(`${this.id}BtnSave`)
      .attachEvent('onItemClick', () => {

        this.SaveWnd.show({
          coordinates: this.newCoordinates,
          area: this.area
        })
      })
    $$(`${this.id}BtnRegions`)
      .attachEvent('onItemClick', () => location.href = "#/geo")
  }

  /**
   * Преобразуем координаты для краты
   * @param {Array} [coordinates=[]] - массив с координатами (из бекенда)
   */
  coordinatesToMap(coordinates) {
    const coordinatesToMap = []
    if (coordinates && coordinates.length) {
      coordinates.forEach(c => {
        coordinatesToMap.push([c.x, c.y])
      })
    }

    return coordinatesToMap
  }

  /**
   * Наристовать зону
   */
  startDrawing() {
    $$(`${this.id}BtnStart`)
      .hide()
    $$(`${this.id}BtnStop`)
      .show()
    $$(`${this.id}BtnSave`)
      .hide()

    this.polygon.editor.startDrawing()
  }

  /**
   * Окончить рисование зоны
   */
  stopDrawing() {
    $$(`${this.id}BtnStop`)
      .hide()
    $$(`${this.id}BtnStart`)
      .show()
    this.polygon.editor.stopDrawing()
    this.polygon.editor.stopEditing()

    this.newCoordinates = this.polygon.geometry.getCoordinates()[0]

    if (this.newCoordinates && this.newCoordinates.length > 2) {
      $$(`${this.id}BtnSave`)
        .show()
    }
  }

  getAreaById = async (id) => {
    $$(this.id)
      .showProgress({
        type: 'icon'
      })
    const response = await geoService.getAreaById(id)
    const area = response.data.areas
    this.area = area

    if (area && area.shapes && area.shapes.length) {
      area.shapes
        .forEach(v => this
          .createPoligon(v.polygon && v.polygon.geometry ? this
            .coordinatesToMap(v.polygon.geometry) : []))
    }

    $$(this.id)
      .hideProgress()
  }

  /**
   * Очистить карту
   */
  clean() {
    webix.confirm({
      title: 'Очистить зону ?',
      ok: 'Да',
      cancel: 'Нет',
      type: 'confirm-warning',
      text: '',
      callback: result => {
        if (result) {
          this.createPoligon()
        }
      }
    })
  }

  /**
   * Создать новый полигон
   * @param {Array} [coordinates=[]] - массив с координатами
   */
  createPoligon(coordinates = []) {
    this.myMap.geoObjects.removeAll()

    this.polygon = new this.ymap.GeoObject({
      geometry: {
        type: 'Polygon',
        coordinates: coordinates.length ? [coordinates] : []
      }
    })
    this.myMap.geoObjects.add(this.polygon)

    this.stopDrawing()

    if (this.polygon && this.polygon.geometry && this.polygon.geometry.getBounds()) {
      this.myMap.setBounds(this.polygon.geometry.getBounds())
    }

    $$(`${this.id}BtnSave`)
      .hide()
  }

  /**
   * Загружаем карту, создаем полигон и инициализируем события
   */
  loadMap = async () => {
    $$(this.id)
      .showProgress({
        type: 'icon'
      })

    this.ymap = await ymaps.load(this.yampsUrl)

    this.myMap = new this.ymap.Map(`${this.id}MapBlock`, {
      center: [55.76, 37.64], // Москва
      zoom: 10,
      controls: ['zoomControl', 'geolocationControl']
    })

    this.eventHandler()

    this.createPoligon()
    $$(this.id)
      .hideProgress()
  }
}


